<agpr-take-over-panel
    [id]="id"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [width]="100"
    [header]="header"
>
    <div
        class="agpr-manageLhpList"
        [agprLoading]="loading"
    >
        <div class="agpr-manageLhpList-toolbar">
            <agpr-filter-dropdown
                [id]="`${id}_filters`"
                class="agpr-manageLhpList-filterDropdown"
                [showQuickFilter]="true"
                [quickFilterPlaceholder]="quickFilterPlaceholder"
                [minLength]="quickFilterMinLength"
                [ariaLabel]="quickFilterPlaceholder"
                [ariaDescribedBy]="'manageLhpList_chips'"
            ></agpr-filter-dropdown>
            <span class="agpr-manageLhpList-filterChips">
                <agpr-filter-chips
                    [id]="`${id}_filters_Chips`"
                ></agpr-filter-chips>
            </span>
            <agpr-button
                [id]="`${id}_toggleView`"
                class="agpr-manageLhpList-toggleView"
                [icon]="showUngroupedView ? 'fa-regular fa-list-tree' : 'fa-regular fa-list'"
                [style]="buttonTypes.icon"
                [tooltip]="showUngroupedView ? 'Discover.leftSidebar.listItemAction.showGroup' : 'Discover.leftSidebar.listItemAction.showList'"
                (click)="toggleUngroupedView()"
            ></agpr-button>
            <agpr-icon-dropdown
                [id]="`${id}_visibility`"
                class="agpr-manageLhpList-visibility"
                displayIcon="fa-regular fa-duotone fa-eye"
                [options]="visibilityOptions"
                [(ngModel)]="selectedVisibilityOption"
                (ngModelChange)="setVisibilityOption($event)"
                inputTooltip="Common.lhp.manageList.dialog.viewOptions"
            ></agpr-icon-dropdown>
        </div>
        <agpr-grouped-table
            [id]="`${id}_table`"
            class="agpr-manageLhpList-table"
            [columns]="tableColumnDefs"
            [sortColumn]="itemNameColumn"
            [sortAscending]="true"
            [(ngModel)]="rowData"
            (ngModelChange)="checkForSelected()"
            (itemChanged)="updateItem($event)"
            (groupChanged)="updateGroup($event)"
            [vsItemSize]="48"
            [vsMinBufferPx]="1000"
            [vsMaxBufferPx]="2000"
            [noContentMessage]="noContentMessage"
            [showGroupHeaders]="showSingleGroupHeader && !showUngroupedView"
        ></agpr-grouped-table>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-split-button
            [id]="`${id}_actions`"
            [style]="buttonTypes.primaryB"
            label="actions"
            [options]="bulkActions"
            [disabled]="selectedGroups.length === 0 && selectedItems.length === 0"
            [caretDown]="false"
            panelPositionY="top"
            panelPositionX="right"
        ></agpr-split-button>
        <agpr-button
            [id]="`${id}_create`"
            label="Common.lhp.manageList.create"
            [style]="buttonTypes.primaryB"
            (click)="createGroup()"
        ></agpr-button>
        <agpr-button
            [id]="`${id}_cancel`"
            label="close"
            [style]="buttonTypes.primary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template
    #actionCell
    let-row="row"
    let-rowIndex="rowIndex"
>
    <div
        [agprLoading]="row.loading"
        [loadingSmallIndicator]="true"
    >
        <agpr-kebab-menu
            [id]="`${id}_kebabMenu_${rowIndex}`"
            class="agpr-manageLhpList-actionButton"
            [options]="row.actions"
            [data]="row"
            [initiallyFocusable]="false"
            [panelPositionX]="panelPosition.right"
        ></agpr-kebab-menu>
    </div>

</ng-template>
<ng-template
    #tagsCell
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-colIndex="colIndex"
>
    <agpr-chip-container
        [id]="`${id}_autoTags_${rowIndex}_${colIndex}`"
        [chips]="row[column.field]"
        [emptyMessage]="'Common.lhp.manageList.dialog.column.noTags'"
        [readonly]="true"
        [ariaLabelledBy]="'manageLhpListTable_tableHeader+' +  colIndex"
    ></agpr-chip-container>
</ng-template>
